import * as PropTypes from "prop-types";

export const customerInterface = {
  id: PropTypes.number,
  fullName: PropTypes.string,
  email: PropTypes.string,
};

export const employeeInterface = {
  id: PropTypes.number,
  fullName: PropTypes.string,
};
